import React from 'react'

interface AccordionGroupContextProps {
  expandedPanel?: string | false
  onPanelChange?: (panel: string) => (isExpanded: boolean) => void
}

export const AccordionGroupContext = React.createContext<AccordionGroupContextProps>({})
